const status = {
    success: "success",
    error: "error",
};

export default status;
